import { Module } from 'vuex-smart-module';
import GlobalSearchActions from './actions';
import GlobalSearchGetters from './getters';
import GlobalSearchMutations from './mutations';
import GobalSearchState from './state';

export default new Module({
  state: GobalSearchState,
  mutations: GlobalSearchMutations,
  actions: GlobalSearchActions,
  getters: GlobalSearchGetters,
});
